export default "__VITE_ASSET__CmyFlFb4__"